import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { ImageFiles } from "@/assets/images";
import { useState } from "react";
import UploadCreditCard from "./upload-credit-card";
import useCurrentTokenBalance from "./useCurrentTokenBalance";

export default function UploadCreditCardPopover() {
  const [isCoinDropdownOpen, setIsCoinDropdownOpen] = useState(false);
  const { currentTokenBalanceFormatted } = useCurrentTokenBalance();
  return (
    <DropdownMenu
      open={isCoinDropdownOpen}
      onOpenChange={setIsCoinDropdownOpen}
    >
      <DropdownMenuTrigger asChild>
        <div className="flex items-center gap-1.5 mr-[13px] cursor-pointer">
          <img src={ImageFiles.CoinPng} alt="bell" width={20} height={20} />
          <span className="text-[13px] text-zinc-950 font-500">
            {currentTokenBalanceFormatted}
          </span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-auto p-0 mt-1 rounded-[16px] !border-none"
        align="end"
      >
        <UploadCreditCard isHeader={true} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
